import { useSetPageTitle } from "@/context/PageTitleContext";
import { Route, Routes } from "react-router-dom";
import CircularsManagement from "./circulars-management";

const CircularManagementRoutes = () => {
  useSetPageTitle("Gestione circolari", "Pubblica e gestisci le comunicazioni");
  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <Routes>
          <Route index element={<CircularsManagement />} />
        </Routes>
      </div>
    </div>
  );
};

export default CircularManagementRoutes;
